/* eslint-disable */
import { makeStyles } from '@rentacenter/racstrap';

const OpenSansBold = 'OpenSans-bold';
export function barcodeStyles(){
    const useClasses = makeStyles((theme) => ({
      displayflex: {
      display: 'flex',
      flexDirection: 'row',
      marginTop: '15px',
    },
    ml0px: {
      marginLeft: '0px',
    },
    ml15px: {
      marginLeft: '15px',
    },
    ml30px: {
      marginLeft: '30px',
    },
    pl50px: {
      paddingLeft: '55px',
    },
    pl315px: {
      paddingLeft: '315px',
    },
    pl165px: {
      paddingLeft: '165px',
    },
    pl200px: {
      paddingLeft: '200px',
    },
    pl245px: {
      paddingLeft: '245px',
    },
    pl185px: {
      paddingLeft: '185px',
    },
    mt5px: {
      marginTop: '5px',
    },
    printallbtn: {
      maxWidth: '115px',
      maxHeight: '30px',
    },
    maxWidth700px: {
      '& div': {
        '& div': {
          maxWidth: '700px',
        },
      },
    },
    maxWidth500px: {
      '& div': {
        '& div': {
          maxWidth: '500px',
        },
      },
    },
    fz20px: {
      '& h5': {
        fontSize: '25px',
      },
      '@media print': {
        display: 'none',
        overflow: 'hidden',
      },
    },
    radioOption: {
      fontWeight: 'bold',
      fontFamily: 'OpenSans-bold',
      color: '#000000',
    },
    radioOptionBgColor: {
      minHeight: '50px',
      margin: '10px 15px',
      backgroundColor: 'whitesmoke',
      paddingTop: '5px',
    },
    pl25px: {
      paddingLeft: '25px',
    },
    h11vh: {
      height: '11vh',
    },
    viewLink: {
      cursor: 'pointer',
      color: '#0077ee',
      textDecoration: 'underline',
      paddingLeft: '10px',
    },
    disabledLink: {
      cursor: 'not-allowed',
      color: '#808080', // Gray color
      textDecoration: 'underline',
      pointerEvents: 'none',
    },
    tableCell: {
      textAlign: 'center',
      padding: '12px 24px',
      verticalAlign: 'middle',
    },
    agreementCell: {
      textAlign: 'left',
      padding: '12px 24px',
      verticalAlign: 'middle',
    },
    tooltipContainer: {
      display: 'inline-block',
      position: 'relative',
      borderRadius: '30px',
    },
    tooltipText: {
      width: '335px',
      visibility: 'hidden',
      opacity: 0,
      position: 'absolute',
      left: '100px',
      transform: 'translateX(-50%)',
      top: '-60px',
      background: '#fff',
      backgroundColor: 'gray',
      color: 'white',
      border: '1px solid #eee',
      borderRadius: 4,
      padding: 8,
      zIndex: 10,
      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
      transition: 'opacity 0.3s, visibility 0s linear 0.3s',
    },
    tooltipVisible: {
      visibility: 'visible',
      opacity: 1,
    },
    racGrid: {
      width: '100%', // Adjust as necessary
      borderCollapse: 'collapse', // Example style, adjust as necessary
    },
    mb32: {
      marginBottom: '32px',
    },
    textCenter: {
      textAlign: 'center',
    },
    margin20px: {
      margin: '20px',
    },
    barcodeModal: {
      margin: '5px',
      marginTop: '0px',
      padding: '0px',
      paddingTop: '0px',
      border: '1px solid gray',
      borderRadius: '15px',
    },
    p15px: {
      padding: '15px',
    },
    BarcodeTitle: {
      marginBottom: 16,
      fontFamily: OpenSansBold,
      fontSize: '21px',
      marginLeft: '85px',
      marginTop: '-10px',
    },
    mb20px: {
      marginBottom: '20px',
    },
    listTitle: {
      fontFamily: OpenSansBold,
      fontSize: '16px',
      fontWeight: 500,
    },
    ml15pxngray: {
      marginLeft: '4px',
      color: 'gray',
    },
    barcodeDateCss:{
      margin: '0.125rem',
      padding: 0,
      fontFamily: 'OpenSans-semibold',
      marginLeft: '4px',
      color: 'gray',
    },
    barcodeGrid: {
      justifyContent: 'center',
      backgroundColor: 'whitesmoke',
      alignItems: 'center',
    },
    displayflexgrid: {
      display: 'flex',
      flexDirection: 'row',
      marginTop: '15px',
      justifyContent: 'space-between',
    },
    mx1: {
      marginRight: theme.typography.pxToRem(4),
      marginLeft: theme.typography.pxToRem(4),
    },
    mr100px: {
      marginRight: '100px',
    },
    ml55px: {
      marginLeft: '55px',
    },
    respMl55px: {
      marginLeft: '55px',
      '@media (max-width: 600px) and (max-height: 960px)': {
        marginLeft: '0px',
      },
      '@media (max-width: 900px) and (max-height: 1280px)': {
        width: '100%',
        overflowX: 'auto',
      },
    },
    respwidth265px: {
      marginBottom: '20px',
      '@media (max-width: 600px) and (max-height: 960px)': {
        maxWidth: '265px',
        marginBottom: '20px',
      },
      '@media (max-width: 900px) and (max-height: 1280px)': {
        maxWidth: '340px',
        marginBottom: '20px',
      },
    },
    mxwidth320px: {
      '& div': {
        '& div': {
          maxWidth: '320px',
        },
      },
    },
    noPrint: {
      '@media print': {
        display: 'none',
      },
    },
    cellStyle: {
       padding: '10px',
        backgroundColor: '#fffcfcff' 
    },
    maxWidth800px: {
      '& div': {
        '& div': {
          maxWidth: '800px',
        },
      },
    },
    maxWidth850px: {
      '& div': {
        '& div': {
          maxWidth: '850px',
        },
      },
    }
      }));
      const classes=useClasses()
      return classes
}


